import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import i18n from '../../i18n/index';

const MySwal = withReactContent(Swal);

export const alertService = {
    sucesso,
    erro,
    aviso,
    confirmar,
    toast
};

// ✅ Sucesso
function sucesso(titulo: string, mensagem?: string) {
    return MySwal.fire({
        title: titulo,
        text: mensagem,
        icon: 'success',
        confirmButtonColor: '#3085d6',
    });
}

// ❌ Erro
function erro(titulo: string, mensagem?: string) {
    return MySwal.fire({
        title: titulo,
        text: mensagem,
        icon: 'error',
        confirmButtonColor: '#d33',
    });
}

// ⚠️ Aviso
function aviso(titulo: string, mensagem?: string) {
    return MySwal.fire({
        title: titulo,
        text: mensagem,
        icon: 'warning',
        confirmButtonColor: '#f0ad4e',
    });
}

// 🤔 Confirmação (Sim/Não)
function confirmar(titulo: string, mensagem: string) {
    return MySwal.fire({
        title: titulo,
        text: mensagem,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: i18n.t('ALERT_CONFIRM_YES') as string,
        cancelButtonText: i18n.t('ALERT_CONFIRM_NO') as string,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
    });
}

// 🔔 Toasts rápidos
function toast(
    mensagem: string,
    tipo: 'success' | 'error' | 'info' | 'warning' = 'success'
) {
    return MySwal.fire({
        toast: true,
        position: 'top-end',
        icon: tipo,
        title: mensagem,
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
    });
}
